const KEY = "px_plan";

export const setChosenPlan = (name, price) => {
  try { localStorage.setItem(KEY, JSON.stringify({ name, price })); } catch {}
  window.dispatchEvent(new CustomEvent("px-plan-change", { detail: { name, price } }));
};

export const getChosenPlan = () => {
  try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; }
};
